// 列挙専用
export const DATA_CLASSIFICATION = {
  All: {
    code: 99,
    text: "指定しない",
  },
  Final: {
    code: 1,
    text: "確定申告",
  },
  Amended: {
    code: 2,
    text: "修正申告",
  },
  Provisional: {
    code: 3,
    text: "予定申告",
  },
  Interim: {
    code: 4,
    text: "中間申告",
  },
  Estimated: {
    code: 5,
    text: "見込納付",
  },
  Quarterly: {
    code: 6,
    text: "四半期試算",
  },
  New: {
    code: 38,
    text: "新規",
  },
  Addition: {
    code: 39,
    text: "追加",
  },
  Correction: {
    code: 40,
    text: "訂正",
  },
  Invalid: {
    code: 41,
    text: "無効(取消)",
  },
  None: {
    code: 0,
    text: "区分なし",
  },

  // Quarterly1:6, //四半期試算(1/4)
  // Quarterly2:7, //四半期試算(2/4)
  // Quarterly3:8, //四半期試算(3/4)
  // Quarterly4:9, //四半期試算(4/4)
  // Provisional1_3:10, //予定申告(1/3)
  // Provisional2_3:11, //予定申告(2/3)
  // Provisional3_3:12, //予定申告(3/3)
  // Provisional1_11:13, //予定申告(1/11)
  // Provisional2_11:14, //予定申告(2/11)
  // Provisional3_11:15, //予定申告(3/11)
  // Provisional4_11:16, //予定申告(4/11)
  // Provisional5_11:17, //予定申告(5/11)
  // Provisional6_11:18, //予定申告(6/11)
  // Provisional7_11:19, //予定申告(7/11)
  // Provisional8_11:20, //予定申告(8/11)
  // Provisional9_11:21, //予定申告(9/11)
  // Provisional10_11:22, //予定申告(10/11)
  // Provisional11_11:23, //予定申告(11/11)
  // Interim1_3:24, //中間申告(1/3)
  // Interim2_3:25, //中間申告(2/3)
  // Interim3_3:26, //中間申告(3/3)
  // Interim1_11:27, //中間申告(1/11)
  // Interim2_11:28, //中間申告(2/11)
  // Interim3_11:29, //中間申告(3/11)
  // Interim4_11:30, //中間申告(4/11)
  // Interim5_11:31, //中間申告(5/11)
  // Interim6_11:32, //中間申告(6/11)
  // Interim7_11:33, //中間申告(7/11)
  // Interim8_11:34, //中間申告(8/11)
  // Interim9_11:35, //中間申告(9/11)
  // Interim10_11:36, //中間申告(10/11)
  // Interim11_11:37, //中間申告(11/11)
  // New:38, //新規
  // Addition:39, //追加
  // Correction:40, //訂正
  // Invalid:41, //無効(取消)
  // Invalid:0→99, //指定しない
  // Invalid:0, //区分なし
};

export const NOTIFICATION_STATUS = {
  noNotification: {
    code: 0,
    text: "未通知",
  },
  notified: {
    code: 1,
    text: "通知済",
  },
};
export const CORPORATION_INDIVIDUAL_DIVISION = {
  Both: {
    code: 0,
    text: "両方",
  },
  LegalEntity: {
    code: 1,
    text: "法人",
  },
  Individual: {
    code: 2,
    text: "個人",
  },
};

export const ACCOUNT_LOCK_INFO = {
  noLock: {
    code: 0,
    text: "しない",
  },
  lock: {
    code: 1,
    text: "する",
  },
};

export const NOTIFICATION_STATUS_ADD = {
  auto: {
    code: 0,
    text: "自動",
  },
  hand: {
    code: 1,
    text: "手動",
  },
};
export const ACCESS_AUTH = {
  group: {
    code: 0,
    text: "グループ",
  },
  admin: {
    code: 1,
    text: "管理者",
  },
  adminUser: {
    code: 2,
    text: "管理ユーザー",
  },
  generalUser: {
    code: 3,
    text: "一般ユーザー",
  },
};

export const TREAM_TARGET = {

  businessOperator: {
    code: 2,
    text: "事業者情報",
  },
  collectedDocument: {
    code: 1,
    text: "収集・配信情報",
  },
  fileManage: {
        code: 3,
        text: 'ファイル管理'
    },  
   businessOperatorEmployee: {
    code: 4,
    text: "社員情報",
  },
};

export const OPERATION_STATUS = {
  create: {
    code: 1,
    text: "新規作成",
  },
  open: {
    code: 2,
    text: "開く",
  },
  save: {
    code: 3,
    text: "保存",
  },
  delete: {
    code: 4,
    text: "削除",
  },
  move: {
    code: 5,
    text: "移動",
  },
  loginOut: {
    code: 6,
    text: "ログアウト",
  },
};

export const OPERATION_STATUS_LOGIN = {
  login: {
    code: 1,
    text: "ログイン",
  },
  loginOut: {
    code: 2,
    text: "ログアウト",
  },
};

export const HAD_SIGNED_IN = {
  notLogin: {
    code: 0,
    text: "未ログイン",
  },
  alreadyLogin: {
    code: 1,
    text: "ログイン済",
  },
};

// 書類収集ステータス
export const DOCUMENT_STATUS_INFO = {
  Unrequested: {
    code: 1,
    text: "未依頼",
  },
  Requested: {
    code: 2,
    text: "依頼済、未提出",
  },
  Waiting: {
    code: 3,
    text: "依頼済(書類提出待)",
  },
  AnyCollected: {
    code: 4,
    text: "依頼済(一部提出済)、一部提出済",
  },
  Collected: {
    code: 5,
    text: "収集済、提出済",
  },
  NotSubmit: {
    code: 6,
    text: "収集済(提出無し)",
  },
  ReRequested: {
    code: 7,
    text: "再依頼、再通知",
  },
  ReWaiting: {
    code: 8,
    text: "再依頼(書類提出待)",
  },
  ReAnyCollected: {
    code: 9,
    text: "再依頼(一部提出済)、一部提出済",
  },
  Checked: {
    code: 10,
    text: "確認済",
  },
};

export const HAD_OR_NOT = {
  had: {
    code: true,
    text: "有り",
  },
  not: {
    code: false,
    text: "無し",
  },
};

// ファイルステータス
export const COLLECT_FILE_STATUS_INFO = {
  Working: {
    code: 1,
    text: "作業中",
  },
  Unchecked: {
    code: 2,
    text: "未確認",
  },
  ReRequested: {
    code: 3,
    text: "再依頼",
  },
  Checked: {
    code: 4,
    text: "確認済",
  },
};

// システムステータス
export const LOGININ_SYSTEM_STATUS_INFO = {
    CollectionDelivery: {
        code: 1,
        text: '集配信'
    },
    Electricity: {
        code: 2,
        text: '電帳'
    }
}
// ユーザーの権限種別
export const USER_AUTHORITY_TYPE = {
  Both: {
    code: 1,
    text: "Admin",
  },
  LegalEntity: {
    code: 2,
    text: "AdminUser",
  },
  Individual: {
    code: 3,
    text: "User",
  },
};
// ファイ理管理の操作履歴
export const FILEMANAGE_OPERATION_STATUS = {
    create: {
        code: 1,
        text: '新規作成'
    },
    open: {
        code: 2,
        text: '開く'
    },
    save: {
        code: 3,
        text: '保存'
    },
    delete: {
        code: 4,
        text: '削除'
    },
    move: {
        code: 5,
        text: '移動'
    },
};

// FormRow コンポーネント タイプ
export const FORM_ROW_COMPONENT_TYPE = {
  INPUT: "input",
  SELECT: "select",
  SELECT_INPUT: "selectInput",
  DATE: "date",
  POST: "post",
  CURRENCY: "currency",
};

/**
 * 社員収集状況
 * @typedef {Object} EmployeeCollectionStatus
 *
 * 未収集のステータスを定義します。
 * @property {Object} NOT_COLLECTED - 未収集
 * @property {string} NOT_COLLECTED.text - ステータス名
 * @property {string} NOT_COLLECTED.path - 画像パス
 *
 * 依頼済のステータスを定義します。
 * @property {Object} REQUESTED - 依頼済
 * @property {string} REQUESTED.text - ステータス名
 * @property {string} REQUESTED.path - 画像パス
 *
 * 収集済のステータスを定義します。
 * @property {Object} COLLECTED - 収集済
 * @property {string} COLLECTED.text - ステータス名
 * @property {string} COLLECTED.path - 画像パス
 *
 * 確認済のステータスを定義します。
 * @property {Object} CONFIRMED - 確認済
 * @property {string} CONFIRMED.text - ステータス名
 * @property {string} CONFIRMED.path - 画像パス
 *
 * 差戻しのステータスを定義します。
 * @property {Object} RETURNED - 差戻し
 * @property {string} RETURNED.text - ステータス名
 * @property {string} RETURNED.path - 画像パス
 *
 * 期限切れのステータスを定義します。
 * @property {Object} EXPIRED - 期限切れ
 * @property {string} EXPIRED.text - ステータス名
 * @property {string} EXPIRED.path - 画像パス
 */
export const EMPLOYEE_COLLECTION_STATUS = {
  NONE: {
    code: 0,
    text: "処理対象外",
    path: "",
  },
  UN_REQUESTED: {
    code: 1,
    text: "未収集",
    path: "label_request_m1.png",
  },
  REQUESTED: {
    code: 2,
    text: "依頼済",
    path: "label_request_m2.png",
  },
  COLLECTED: {
    code: 3,
    text: "収集済",
    path: "label_request_m3.png",
  },
  REMAND: {
    code: 4,
    text: "差戻し",
    path: "label_request_m6.png",
  },
  CHECKED: {
    code: 5,
    text: "確認済",
    path: "label_request_m5.png",
  },
  EXPIRED: {
    code: 6,
    text: "期限切れ",
    path: "label_request_m7.png",
  },
};

export const COLLECT_MODE_LIST = {
  ONLINE: {
    code: 1,
    text: "オンライン",
    name: "Web",
  },
  PAPER: {
    code: 2,
    text: "書面",
    name: "Paper",
  },
};

// 年末調整
export const NC_ADJUSTMENT_TYPE_LIST = {
  VALID: {
    code: 0,
    text: "する",
  },
  NOT_SUBMITTED: {
    code: 1,
    text: "しない",
    subtext: "（申告書未提出）",
  },
  RETIREES: {
    code: 2,
    text: "しない",
    subtext: "（退職者）",
  },
  COLUMN_OTSU: {
    code: 3,
    text: "しない",
    subtext: "（乙欄）",
  },
  INCOMPLETE_DOCUMENTS: {
    code: 4,
    text: "しない",
    subtext: "（書類不備）",
  },
  NON_TARGET_PAYROLL: {
    code: 5,
    text: "しない",
    subtext: "（給与対象外）",
  },
  OTHER: {
    code: 6,
    text: "しない",
    subtext: "（その他）",
  },
  VOID: {
    code: 7,
    text: "対象外",
  },
  INVALID: {
    text: "しない",
  },
};

// 申告書収集状況
export const DECLARATION_COLLECT_STATUS = {
  VOID: {
    code: 0,
    text: "-",
  },
  PREPARING: {
    code: 1,
    text: "準備中",
  },
  CREATING: {
    code: 2,
    text: "作成中",
  },
  UNCONFIRMED: {
    code: 3,
    text: "未確認",
  },
  POINTED_OUT: {
    code: 4,
    text: "指摘有",
  },
  CONFIRMED: {
    code: 5,
    text: "確認済",
  },
};

export const CURRENT_SITUATION_LIST = {
  EMPLOYED: {
    code: 0,
    text: "在職",
  },
  RETIRED: {
    code: 1,
    text: "退職",
  },
  RETIRED_FOR_DEATH: {
    code: 2,
    text: "死亡退職",
  },
  LEAVE_OF_ABSENCE: {
    code: 3,
    text: "休職",
  },
  OTHER: {
    text: "-",
  },
};

/**
 * 年末調整添付ファイル種別を表します。
 * @enum {number}
 */
export const TZCR_NC_ATTACHMENT_FILE_TYPE = {
  /**
   * 前職の源泉徴収票
   */
  PreviousWithholdingSlip: 0,
  /**
   * 学生証等
   */
  StudentIdCard: 1,
  /**
   * 本人障がい者手帳
   */
  DisabilityCertificate: 2,
  /**
   * 配偶者親族関係書類
   */
  SpouseRelativesDocument: 3,
  /**
   * 配偶者送金関係書類
   */
  SpouseRemittanceDocument: 4,
  /**
   * 配偶者障がい者手帳
   */
  SpouseDisabilityCertificate: 5,
  /**
   * 扶養親族親戚関係書類
   */
  DependentsRelativesDocument: 6,
  /**
   * 扶養親族送金関係書類
   */
  DependentsRemittanceDocument: 7,
  /**
   * 扶養親族留学関係書類
   */
  DependentsStudyAbroadDocument: 8,
  /**
   * 扶養親族障がい者手帳
   */
  DependentsDisabilityCertificate: 9,
  /**
   * 生命保険料控除証明書
   */
  LifeInsuranceDeductionCertificate: 10,
  /**
   * 地震保険料控除証明書
   */
  EarthquakeInsuranceDeductionCertificate: 11,
  /**
   * 社会保険料控除証明書
   */
  SocialInsuranceDeductionCertificate: 12,
  /**
   * 小規模企業共済等掛金払込証明書
   */
  SmallScaleEnterprisePaymentCertificate: 13,
  /**
   * (特定増改築等)住宅借入金等特別控除証明書
   */
  HousingLoanSpecialDeductionCertificate: 14,
  /**
   * 住宅取得資金に関する借入金の年末残高証明書
   */
  HousingLoanBalanceCertificate: 15,
};

/**
 * 社員配信状況
 * @typedef {Object} EmployeeDistributionStatus
 *
 * 処理対象外のステータスを定義します。
 * @property {Object} None - 処理対象外
 * @property {string} None.text - ステータス名
 * @property {string} None.path - 画像パス
 *
 * 未配信のステータスを定義します。
 * @property {Object} UN_DISTRIBUTED - 未配信の
 * @property {string} UN_DISTRIBUTED.text - ステータス名
 * @property {string} UN_DISTRIBUTED.path - 画像パス
 *
 * 配信済のステータスを定義します。
 * @property {Object} DISTRIBUTED - 配信済
 * @property {string} DISTRIBUTED.text - ステータス名
 * @property {string} DISTRIBUTED.path - 画像パス
 *
 * 受信確認済のステータスを定義します。
 * @property {Object} CHECKED - 受信確認済
 * @property {string} CHECKED.text - ステータス名
 * @property {string} CHECKED.path - 画像パス
 */
export const EMPLOYEE_DISTRIBUTION_STATUS = {
  NONE: {
    code: 0,
    text: "処理対象外",
    path: "",
  },
  UN_DISTRIBUTED: {
    code: 1,
    text: "未配信",
    path: "label_delivery1.png",
  },
  DISTRIBUTED: {
    code: 2,
    text: "配信済",
    path: "label_delivery2.png",
  },
  CHECKED: {
    code: 3,
    text: "受信確認済",
    path: "label_delivery3.png",
  },
};

/**
 * 処理中進捗状況
 * @typedef {Object} PROGRESS_STATUS
 *
 */
export const PROGRESS_STATUS = {
  // 未処理
  NONE: 0,
  // 処理中
  IN_PROGRESS: 1,
  // 処理済（エラーあり）
  ERROR: 2,
  // 例外発生
  EXCEPTION: 3,
  // 処理済（エラーなし）
  COMPLETED: 4,
};

// 事業者利用権限
export const BOP_FUNCTION_USAGE_AUTHORITY = {
  NONE: {
    code: -1,
    text: "未設定",
  },
  PERMISSION: {
    code: 0,
    text: "許可",
  },
  DENY: {
    code: 1,
    text: "拒否",
  },
};

// アクセス権限設定モード
export const ACCESS_AUTHORITY_SETTING_MODE = {
  None: {
    code: 0,
    text: "すべての利用者を許可",
  },
  Set: {
    code: 1,
    text: "指定した利用者を許可",
  },
};

// アカウント通知モード
export const ACCOUNT_NOTIFY_STATUS = {
  Unnotified: {
    code: 0,
    text: "未通知",
  },
  NotifiedByEmail: {
    code: 1,
    text: "通知済\n(メール)",
  },
  NotifiedByExcel: {
    code: 2,
    text: "通知済\n(Excel)",
  },
};

// 社員アカウント通知モード
export const EMPLOYEE_NOTIFY_STATUS = {
  Unnotified: {
    code: 0,
    text: "未通知",
  },
  NotifiedByEmail: {
    code: 1,
    text: "通知済\n(メール)",
  },
  NotifiedByExcel: {
    code: 2,
    text: "通知済\n(ファイル)",
  },
};